import './App.css'
import './firebase'

import { BrowserRouter, useRoutes } from 'react-router-dom'

import Desktop from './Desktop'
import Mobile from './Mobile'
import Payment from './policy/payment'
import Privacy from './policy/privacy'
import Terms from './policy/terms'
import Contact from './contact'
import Faq  from './faq'
import Support from './pages/Support'
import Tutorial from './Tutorial'
import Thanks from './pages/Thanks'
import Download from './pages/Download'
import NotFound from './NotFound'

import {
  useReducer,
} from 'react'

import {
  Context,
  initialState,
} from './store/Context'

import {
  reducer,
} from './store/reducer'

function RouteElementsDesktop() {
  const routeElements = useRoutes([
    { path: '/', element: <Desktop /> },
    { path: '/policy/payment', element: <Payment /> },
    { path: '/policy/privacy', element: <Privacy /> },
    { path: '/policy/terms', element: <Terms /> },
    { path: '/contact', element: <Contact/> },
    { path: '/faq', element: <Faq/> },
    { path: '/support', element: <Support/> },
    { path: '/tutorial', element: <Tutorial/> },
    { path: '/thanks', element: <Thanks/> },
    { path: '/download', element: <Download/> },
    { path: '*', element: <NotFound /> }
  ]);
  return routeElements
}

function RouteElementsMobile() {
  const routeElements = useRoutes([
    { path: '/', element: <Mobile /> },
    { path: '/policy/payment', element: <Payment /> },
    { path: '/policy/privacy', element: <Privacy /> },
    { path: '/policy/terms', element: <Terms /> },
    { path: '/contact', element: <Contact/> },
    { path: '/faq', element: <Faq/> },
    { path: '/support', element: <Support/> },
    { path: '/tutorial', element: <Tutorial/> },
    { path: '/thanks', element: <Thanks/> },
    { path: '/download', element: <Download/> },
    { path: '*', element: <NotFound /> }
  ]);
  return routeElements
}

function DesktopApp() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const value = {state, dispatch}
  
  return (
    <Context.Provider value={value}>
      <BrowserRouter>
        <RouteElementsDesktop />
      </BrowserRouter>
    </Context.Provider>
  )
}

function MobileApp() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const value = {state, dispatch}

  return (
    <Context.Provider value={value}>
      <BrowserRouter>
        <RouteElementsMobile />
      </BrowserRouter>
    </Context.Provider>
  )
}

function App() {
  function isDesktop() {
    return 850 < window.innerWidth
  }

  return (
    <>
    {
      isDesktop() ? <DesktopApp /> : <MobileApp />
    }
    </>
  )
}

export default App
